import { trigger, transition, style, animate } from "@angular/animations";

export const fadeInOut = trigger("fadeInOut", [
  transition(":enter", [
    style({ opacity: 0 }),
    animate("300ms ease-in", style({ opacity: 1 })),
  ]),
  transition(":leave", [animate("300ms ease-out", style({ opacity: 0 }))]),
]);

export const longFadeInOut = trigger("fadeInOut", [
  transition(":enter", [
    style({ opacity: 0 }),
    animate("900ms ease-in", style({ opacity: 1 })),
  ]),
  transition(":leave", [animate("900ms ease-out", style({ opacity: 0 }))]),
]);
